import {
    Dialog,
    Grid,
    Button,
    DialogContent,
    Paper,
    Typography,
    SxProps,
    useTheme,
    Theme,
} from '@mui/material'
import CloseDialogButton from 'components/Dialog/CloseDialogButton'
import { NumpadCircleInput } from 'components/PinPanel/NumpadCircleInput'
import { useCallback, useState } from 'react'
const numberDialogStyle = (theme: Theme) => ({
    dialogContainer: {
        width: 450,
        padding: 4,
        background: (t: Theme) => t.palette.primary.main,
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            width: 400,
        },
    },
    cancleButton: {
        marginTop: 4,
        paddingX: 4,
        paddingY: 1,
        background: 'rgba(255, 255, 255, 0.2)',
        color: 'white',
        '&:hover': {
            background: theme.palette.info.main,
            color: 'white',
        },
    },
    textInputContainer: {
        textAlign: 'center',
        justifyContent: 'center',
        width: 350,
        height: 50,
        fontSize: 20,
        mb: 2,
        [theme.breakpoints.down('md')]: {
            width: 300,
        },
    } as SxProps,
})
const NumberDialDialog = ({
    open,
    onClose,
    onSubmit,
}: {
    open: boolean
    onClose: () => void
    onSubmit: (string: string) => void
}) => {
    const theme = useTheme()
    const styles = numberDialogStyle(theme)
    const [text, setText] = useState('')
    const onAppend = (number: string) =>
        setText((t) => {
            t += number
            return t
        })
    const onBackspace = () =>
        setText((text) => {
            const newText = text.slice(0, -1)
            return newText
        })
    const onClear = () => setText('')

    const handleClose = useCallback(() => {
        onClose()
        onClear()
    }, [onClose])
    const handleSubmit = useCallback(() => {
        onSubmit(text)
        handleClose()
    }, [handleClose, onSubmit, text])

    return (
        <Dialog open={open} onClose={handleClose}>
            <CloseDialogButton
                dialogName="number dial dialog"
                onClick={handleClose}
            />
            <DialogContent sx={styles.dialogContainer}>
                <Grid
                    container
                    justifyContent="center"
                    alignContent={'flex-start'}
                >
                    <Grid item>
                        <Grid
                            container
                            justifyContent="center"
                            direction="column"
                            alignItems="center"
                        >
                            <Paper sx={styles.textInputContainer}>
                                <Typography mt={1.5} variant="h6">
                                    {text}
                                </Typography>
                            </Paper>
                            <Grid item>
                                <NumpadCircleInput
                                    onClickNumpad={onAppend}
                                    onClickBack={onBackspace}
                                    onClickClear={onClear}
                                    onPressEnter={handleSubmit}
                                    useKeyboard={open}
                                ></NumpadCircleInput>
                            </Grid>
                            <Grid
                                item
                                container
                                justifyContent="flex-end"
                                alignItems="flex-end"
                                spacing={2}
                            >
                                <Grid item>
                                    <Button
                                        sx={styles.cancleButton}
                                        variant="outlined"
                                        size="large"
                                        color="primary"
                                        onClick={handleClose}
                                    >
                                        CLOSE
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        size="large"
                                        color="info"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default NumberDialDialog
